export const EVENT_TAG_ICON_BASE_PATH = `${process.env.PUBLIC_URL}/assets/icons`;

// Icon files must exist under public/assets/icons with the same names.
export const EVENT_TAG_ICONS: string[] = [
	"heart.svg",
	"education.svg",
	"book.svg",
	"recycle.svg",
	"environment.svg",
	"health.svg",
	"animal.svg",
	"children.svg",
	"volunteer.svg",
];

export const getEventTagIconUrl = (iconName: string) => `${EVENT_TAG_ICON_BASE_PATH}/${iconName}`;
